<template>
  <div class="doclib-index">
    <div class="index-header">
      <p>知识库</p>
      <i class="iconfont icon-search" @click="goToSearchPage"></i>
    </div>
    <div class="index-content" @scroll="handleScroll" @touchstart="touchStart" @touchmove="touchMove" @touchend="touchEnd" v-if="!noDoclib">
      <template v-for="(startItem, startIndex) in allList">
        <doclib-card :card-data="startItem" :userInfo="userInfo" :key="startIndex"></doclib-card>
      </template>
    </div>
    <div class="no-doclib" v-else>
      <img src="https://p5.ssl.qhimg.com/t110b9a93019a820ae6cc60c7ca.png" alt="">
      <span>当前暂未创建知识库</span>
    </div>
  </div>
</template>
<script>
import ajax from '@/utils/ajax'
import { LIBRARY_LIST, KBASE_USER_INFO } from '@/config/api'
import DoclibCard from './DoclibCard'
import config from '@/config'
import { CommonMixin } from '../file/commonMixin'
export default {
  name: 'Doclib',
  data () {
    return {
      startList: [],
      allList: [],
      allListPage: 1,
      allListTotalPage: 2,
      noDoclib: false,
      userInfo: {},
      startY: 0,
      freshLoading: false
    }
  },
  mixins: [CommonMixin],
  components: {
    DoclibCard
  },
  created () {
    this.getAllList()
  },
  mounted () {

  },
  methods: {
    getAllList () {
      const promiseList = [
        ajax({
          url: LIBRARY_LIST,
          baseUrl: config.doclib_application_url,
          noPrefix: true,
          data: {
            page_number: this.allListPage,
            page_size: 30
          }
        }),
        ajax({
          url: KBASE_USER_INFO,
          baseUrl: config.doclib_application_url,
          noPrefix: true
        })
      ]
      Promise.all(promiseList).then((values) => {
        if (values.every(item => item.success)) {
          this.allList = this.allList.concat(values[0].data.data_list)
          this.allListTotalPage = values[0].data.total_page
          this.noDoclib = !values[0].data.total_count
          this.userInfo = values[1].data
        }
      })
    },
    getKbaseStarList () {
      ajax({
        url: LIBRARY_LIST,
        baseUrl: config.doclib_application_url,
        noPrefix: true,
        data: {
          page_number: 1,
          page_size: 8,
          type: 1
        }
      }).then(res => {

      })
    },
    handleScroll (e) {
      if (this.checkBottom(e)) {
        this.allListPage = this.allListPage + 1

        if (this.allListPage <= this.allListTotalPage) {
          this.getAllList()
        }
      }
    },
    checkBottom (e) {
      const { scrollTop, scrollHeight, clientHeight } = e.target
      return scrollTop + clientHeight >= scrollHeight - 5 // 留5px的缓冲区
    },
    goToSearchPage () {
      this.appFn({
        action: 'route',
        data: `${window.location.origin}/h5/doclib/search?prev_link=${encodeURIComponent(window.location.href)}`
      }, () => {
        window.open(`${window.location.origin}/h5/doclib/search?prev_link=${encodeURIComponent(window.location.href)}`)
      })
    },
    touchStart (event) {
      this.startY = event.touches[0].clientY
    },
    touchMove (event) {
      const currentY = event.touches[0].clientY
      const distance = currentY - this.startY
      if (distance > 0) { // 向下滑动
        // 判断是否到达顶部
        const fileListScroll = document.getElementsByClassName('index-content')[0].scrollTop
        if (fileListScroll === 0 && distance > 30) {
          this.freshLoading = true
        }
      }
    },
    touchEnd (event) {
      const fileListScroll = document.getElementsByClassName('index-content')[0].scrollTop
      if (fileListScroll === 0 && this.freshLoading) {
        this.freshLoading = false
        this.allListPage = 1
        this.allListTotalPage = 2
        this.allList = []
        this.getAllList()
      }
    }
  }
}
</script>
<style lang="postcss" scoped>
  .doclib-index {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    background: #F9FAFB;

    & .index-header {
      width: 100%;
      display: flex;
      height: 64px;
      padding: 0px 20px;
      justify-content: space-between;
      align-items: center;
      box-sizing: border-box;

      &>p {
        color: #1B2532;
        font-family: "PingFang SC";
        font-size: 22px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
      }

      &>i {
        color: #1B2532;
        font-size: 20px;
        line-height: normal;
      }
    }

    & .index-content {
      height: calc(100% - 64px);
      padding: 20px;
      background: #F9FAFB;
      overflow-y: auto;
      box-sizing: border-box;
    }

    & .no-doclib {
      height: calc(100% - 64px);
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      margin-top: -60px;

      & img {
        width: 220px;
        flex-shrink: 0;
      }

      & span {
        color: #9EA7B8;
        font-family: "PingFang SC";
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 22px;
        margin-top: 4px;
      }
    }
  }
</style>
